import { render, staticRenderFns } from "./WineCard.vue?vue&type=template&id=3bab7578&scoped=true"
import script from "./WineCard.vue?vue&type=script&lang=js"
export * from "./WineCard.vue?vue&type=script&lang=js"
import style0 from "./WineCard.vue?vue&type=style&index=0&id=3bab7578&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab7578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bab7578')) {
      api.createRecord('3bab7578', component.options)
    } else {
      api.reload('3bab7578', component.options)
    }
    module.hot.accept("./WineCard.vue?vue&type=template&id=3bab7578&scoped=true", function () {
      api.rerender('3bab7578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineCard.vue"
export default component.exports